import React from "react";
import PracticeBankAccountService from "../../Services/PracticeBankAccountService";
import { Button, Col, Drawer, Form, Input, Row, Spin } from "antd";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { Utils } from "../../Utilities/Utils";
import { adminContext } from "../../Common/PageRoute";

interface BankDetailsProps {
  practiceId: number;
  recordId?: string | any;
  // onDismiss: (data?: boolean) => void;
  onDismiss: (data?: { isUpdated: boolean; isPrimary?: boolean }) => void;
}

export const AddPracticeBank = ({
  practiceId,
  recordId,
  onDismiss,
}: BankDetailsProps) => {
  const [form] = Form.useForm();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (recordId) {
      setLoading(true);
      const getBankDetails = async () => {
        await PracticeBankAccountService.get(recordId).then((res) => {
          if (res) {
            form.setFieldsValue(res);
            setLoading(false);
          } else {
            console.log("error", res?.message);
            setLoading(false);
          }
        });
      };
      getBankDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordId]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (value) => {
        setLoading(true);
        const payload = { ...value, practiceId };
        let res = await PracticeBankAccountService.create(recordId, payload);
        if (res?.status) {
          setLoading(false);
          onDismiss({
            isUpdated: true,
            isPrimary: res?.result?.primary,
          });
          openNotification("success", "Bank details added successfully.");
        } else {
          setLoading(false);
          openNotification("error", res?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        //openNotification("error", error);
      });
  };

  return (
    <Drawer
      title={recordId ? "Edit bank details" : "Add bank details"}
      placement="right"
      open={true}
      // loading={loading}
      footer={
        <div className="text-right">
          <Button
            className="me-2"
            onClick={() => {
              onDismiss();
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            loading={loading}
            type="primary"
            onClick={() => {
              handleSubmit();
            }}
            disabled={loading}
          >
            Save
          </Button>
        </div>
      }
      extra={
        <CloseOutlined
          style={{ cursor: "pointer" }}
          onClick={() => {
            onDismiss();
          }}
        />
      }
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Form form={form} className="px-3 py-1 mt-2">
          <Row>
            <Col span={24}>
              <Form.Item
                label="Account name"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="accountName"
                rules={[
                  { required: true, message: "Enter account name" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Bank name"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="bankName"
                rules={[
                  { required: true, message: "Enter bank name" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input className="line-height-28" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Account number"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="accountNumber"
                rules={[{ required: true, message: "Enter account number" }]}
              >
                <Input
                  className="line-height-28"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Sort code"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="shortCode"
              >
                <Input
                  className="line-height-28"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="IBAN"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="iban"
              >
                <Input className="line-height-28" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="BIC code"
                className="custom-form-item"
                colon={false}
                labelCol={{ span: 10 }}
                style={{ textAlignLast: "left" }}
                name="bik"
              >
                <Input className="line-height-28" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Drawer>
  );
};
